import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader, remove255 } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_CREATE_NEW_CONTACT_GROUP,
	STR_DESCRIPTON,
	STR_INVALID_EMAIL,
	STR_INVALID_SENDER_ID,
	STR_INVALID_SAMPLE_SMS,
	STR_REQUEST_SENDER_ID,
	STR_FULLNAME,
	STR_EMAIL,
	STR_SENDER_ID,
	STR_SAMPLE_SMS,
	STR_SELECT_PAYMENT_METHOD,
	STR_PAY_WITH_MOBILE,
	STR_PAY_WITH_CARD,
	STR_ENTER_PHONE_NUMBER_FOR_PAYMENT,
	STR_FINALIZE_PAYMENT_MOBILE,
	STR_FINALIZE_PAYMENT_CARD,
	STR_GO_BACK,
	STR_PRICE
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import MobileInterface from "../MobileInterface";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [fullname, setFullname] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState(appContext.currentUserData.phone);
	const [senderId, setSenderId] = useState("");
	const [sampleSms, setSampleSms] = useState("");
	const [payPhone, setPayPhone] = useState(remove255(appContext.currentUserData.phone));
	const [payWith, setPayWith] = useState('mobile_money');
	const [opSuccessful, setOpSuccessful] = useState(false);
	

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	async function sendRequest() {
		if(fullname && fullname.trim().length > 0) {
			if(email && email.trim().length > 0) {
				if(senderId && senderId.trim().length > 0 && senderId.length <= 11) {
					if(sampleSms && sampleSms.trim().length > 0) {
						if(
							(payWith === 'mobile_money' && payPhone.trim().length === 10) ||
							(payWith === 'credit_card')
						) {
							setLoading(true);
							await callApi(
								'send-sender-id-request',
								{
									fullname,
									email,
									phone,
									senderId,
									sampleSms,
									payPhone,
									payWith,
								}
							).then(response => {
								if(response.status === 1) {
									appContext.tellMessage(STR_SUCCESS[appContext.language]);
									setOpSuccessful(true);
									appContext.getAllSenderIdRequests();
									if (payWith === 'credit_card') {
										MobileInterface.openLink(response.payment_gateway_url);
									}
								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError(STR_ENTER_PHONE_NUMBER_FOR_PAYMENT[appContext.language]);
						}
					} else {
						appContext.tellError(STR_INVALID_SAMPLE_SMS[appContext.language]);
					}
				} else {
					appContext.tellError(STR_INVALID_SENDER_ID[appContext.language]);	
				}
			} else {
				appContext.tellError(STR_INVALID_EMAIL[appContext.language]);
			}
		} else {
			appContext.tellError(STR_INVALID_NAME[appContext.language]);
		}
	}


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					<div className="col-md-12">
						<h6
							className="mSectionTitle"
						>
							{STR_REQUEST_SENDER_ID[appContext.language]}
						</h6>
					</div>

					{
						(opSuccessful) ?
						<div className="col-md-12 mt-4 mb-4 text-center" style={{ padding: "40px" }}>
							<h1
								style={{
									fontSize: "20px",
								}}
							>
								<MdCheckCircle size={70} className="text-secondary" /> <br />
								{(payWith === 'mobile_money') ? STR_FINALIZE_PAYMENT_MOBILE[appContext.language] : STR_FINALIZE_PAYMENT_CARD[appContext.language]}
							</h1>

							<button
								className="btn btn-rounded btn-sm btn-padded mt-4 mb-4 btn-dark"
								onClick={() => {
									appContext.navBack();
								}}
							>
								{STR_GO_BACK[appContext.language]}
							</button>
						</div>
						:
						<div className="col-md-12">
							<div className="mb-3 mt-3">
								<label className="form-label">{STR_FULLNAME[appContext.language]}</label>
								<input
									className="form-control"
									value={fullname}
									onChange={(e) => setFullname(e.target.value)}
								/>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_EMAIL[appContext.language]}</label>
								<input
									className="form-control"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_PHONE_NUMBER[appContext.language]}</label>
								<input
									className="form-control"
									value={phone}
									readOnly
									onChange={(e) => setPhone(e.target.value)}
								/>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_SENDER_ID[appContext.language]}</label>
								<input
									className="form-control"
									value={senderId}
									onChange={(e) => setSenderId(e.target.value)}
									maxLength={11}
								/>
								<div className="form-text">
									{senderId.length}/11
								</div>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_SAMPLE_SMS[appContext.language]}</label>
								<textarea
									className="form-control"
									value={sampleSms}
									onChange={(e) => setSampleSms(e.target.value)}
									maxLength={160}
								/>
								<div className="form-text">
									{sampleSms.length}/160
								</div>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_PRICE[appContext.language]}</label>
								<h6
									className="font-semi-bold text-secondary"
									style={{
										fontSize: "36px"
									}}
								>
									{formatMoney(appContext.systemParams.senderIdPrice)} TZS
								</h6>
							</div>

							<div className="mb-3 mt-3">
								<label className="form-label">{STR_SELECT_PAYMENT_METHOD[appContext.language]}</label>
								<select
									className="form-control"
									value={payWith}
									onChange={(e) => setPayWith(e.target.value)}
								>
									<option value='mobile_money'>{STR_PAY_WITH_MOBILE[appContext.language]}</option>
									<option value='credit_card'>{STR_PAY_WITH_CARD[appContext.language]}</option>
								</select>
							</div>

							{
								(payWith === 'mobile_money') ?
								<div className="mb-3 mt-3">
									<label className="form-label">{STR_ENTER_PHONE_NUMBER_FOR_PAYMENT[appContext.language]}</label>
									<input
										className="form-control"
										value={payPhone}
										onChange={(e) => setPayPhone(e.target.value)}
										maxLength={10}
									/>
									
								</div>
								:""
							}

							<div className="mb-3 mt-3 text-end">
								<button
									className="btn btn-rounded bg-secondary btn-padded"
									onClick={sendRequest}
								>
									{STR_SUBMIT[appContext.language]}
								</button>
							</div>

						</div>
					}
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}